
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-4'"/>
      <iframe src="/tms/" style="width:100%; height:100vh; border:0;" loading="lazy"></iframe>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'

export default {
  name: 'AdminTmsManagement',
  components: {
    AdminHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminTmsManagement.vue